import React from "react";

const AnnouncementBar = ({
  announcement,
}: {
  announcement: React.ReactNode;
  classNames?: string;
}): React.ReactElement => (
  <article className="mb-3 justify-content-center notice-background text-sm-center p-2">
    {announcement}
  </article>
);

export default AnnouncementBar;
